import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-modal',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './modal.component.html',
})
export class ModalComponent {
  @Input() open: boolean;
  @Input() overflows?: boolean;
  @Output() onClose = new EventEmitter<void>();
}



// WEBPACK FOOTER //
// ./src/app/shared/components/modal/modal.component.ts